// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editable-row-operations a[data-v-306260ec]{margin-right:8px}.editable-add-btn[data-v-306260ec]{margin-top:8px}#salesform .ant-form-item[data-v-306260ec]{margin-bottom:0!important}#salesform .ant-form-item-control[data-v-306260ec],#salesform .ant-form-item-control-wrapper[data-v-306260ec],#salesform .ant-form-item-label[data-v-306260ec]{padding:0}", ""]);
// Exports
module.exports = exports;
